// removed by extract-text-webpack-plugin
module.exports = {"block":"RrUu30g5qIbjJJOThA1zt","heading":"ek3TaJr9uxAM4iHDvS-iY","container":"xIz91GdjQDQ9EZSpd-p8l","collaborators":"_3s97xczDUm2Gw0DJrCO514","collaborators__item":"_1SN4xNZ_O2ApSGaigD9Rwu","collaborators__title":"_1XNFPI9yaO38coZ04dBCwg","collaborators__content":"djVQUK3lVHEVIYzuTKSxc","icon":"KjUfUDReTDnpObI92Hhlw","readMore":"_2bAv1nbz0TWpm1qJ85Zk0"};


//////////////////
// WEBPACK FOOTER
// ./src/components/CollaboratorLinksBlock/CollaboratorLinksBlock.module.scss
// module id = 741
// module chunks = 0